import { render, staticRenderFns } from "./Huiyuan.vue?vue&type=template&id=189c1f8b&"
import script from "./Huiyuan.vue?vue&type=script&lang=js&"
export * from "./Huiyuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports